module.exports = __webpack_public_path__ + "media/images/iconTrend--up-6e25b1e618d35f433fceb8c716114452.png";